import ajax from '../../lib/userAjax'
import { Store, Module, ActionContext } from 'vuex'
interface UserDetailState {
  avatar: any,
  roleNames: any,
}
class UserDetailStore implements Module<UserDetailState, any>{
  namespaced = true;
  state = {
    avatar: null,
    roleNames: null,
  }
  actions = {
    async init(content: ActionContext<UserDetailState, any>) {
      let rep = await ajax.get('/api/services/app/Session/GetCurrentUser')
      content.state.roleNames = rep.data.result.roleNames;
      content.state.avatar = rep.data.result.avatar;
    }
  }
}
const userDetail = new UserDetailStore();
export default userDetail;